import React, { useContext, useEffect, useState } from 'react'
import { Alert, Box, Button, Card, CardContent, CircularProgress, Popover, Stack, TextField, Typography } from '@mui/material'
import SelectOnMap from './SelectOnMap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Context } from '../../contexts/Context'
import { updateCenter, getCenterById } from '../../services/form/center'

export default function UpdateCenter ({ props }) {
  const { currentLocation, token } = props
  const [mapView, setMapView] = useState(false)
  const { handleToken } = useContext(Context)
  const { id } = useParams()
  const [center, setCenter] = useState(null)
  const [formStatus, setFormStatus] = useState(true)
  const [formResponse, setFormResponse] = useState('')
  const navigate = useNavigate()

  const handleLocation = (coordinates) => {
    const payload = { ...center, location: { type: 'Point', coordinates: [coordinates.lng, coordinates.lat] } }
    setCenter(payload)
  }

  const handleCoordinates = (e) => {
    const { name, value } = e.target
    if (name === 'Latitude') {
      const payload = { ...center, location: { type: 'Point', coordinates: [center.location?.coordinates[0], +value] } }
      setCenter(payload)
    } else {
      const payload = { ...center, location: { type: 'Point', coordinates: [+value, center.location?.coordinates[1]] || '' } }
      setCenter(payload)
    }
  }

  const handleForm = (e) => {
    const { name, value } = e.target

    if (name === 'start' || name === 'end') {
      setCenter({ ...center, workingHours: { ...center.workingHours, [name]: value } })
    } else if (name === 'contact') {
      if (value?.toString().length <= 10) {
        setCenter({ ...center, [name]: value })
      }
    } else setCenter({ ...center, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const payload = {
      id: center._id, // Mongo Id
      location: center.location,
      contact: center.contact,
      workingHours: center.workingHours
    }
    updateCenter(token, payload)
      .then(res => {
        if (res.status === 'Failed') {
          console.log(res.message)
          setFormResponse(res.message)
          setFormStatus(false)
        } else if (res.status === 401) {
          setFormStatus(false)
          handleToken(null)
          // document.cookie = 'fmtaccount=;path=/'
          navigate('/login')
        } else if (res) {
          navigate('/center/' + id)
          setFormStatus(true)
        } else {
          setFormStatus(false)
        }
      })
  }

  const handleFormMap = () => {
    setMapView(false)
  }

  useEffect(() => {
    getCenterById(id, token)
      .then(res => {
        if (res.status === 'Unauthorized') {
          handleToken(null)
          // document.cookie = 'fmtaccount=;path=/'
          navigate('/login')
        } else {
          if (!res.workingHours) {
            res.workingHours = { start: '', end: '' }
          }
          setCenter(res)
        }
      })
    // eslint-disable-next-line
  }, [])

  return (
    <Card sx={{ margin: ' 10px auto', maxWidth: '700px' }}>
      <CardContent>
        <h2>Update Center Details</h2>

        {center
          ? <form style={{ display: 'flex', flexDirection: 'column', gap: '5px', margin: '20px auto' }} onSubmit={handleSubmit} action='post'>
            <Card variant='outlined' sx={{ padding: '0px 15px 15px', marginBottom: '5px' }}>
              <Typography variant='h5' sx={{ fontSize: 'md', mt: 2 }}>
                {center.centerName || ''}
              </Typography>
              <Typography variant='h7'>
                {(center.address?.address1 || '') + ' ' + (center.address?.address2 || '') + ' ' + (center.address?.city || '')}
              </Typography>
            </Card>

            <TextField
              sx={{ margin: '10px 0' }}
              onChange={handleForm}
              required
              name='contact'
              type='number'
              inputProps={{ max: 10 }}
              id='outlined-required'
              label='Phone number'
              value={center.contact || ''}
              InputLabelProps={{
                shrink: true
              }}
            />
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '49% 49%',
                gap: '1em',
                '& > :not(style)': { mb: 1, mt: 1 }
              }}
            >
              {['start', 'end'].map((e, i) => {
                let val
                if (i === 0) val = center.workingHours?.start || ''
                else val = center.workingHours?.end || ''
                return (
                  <TextField
                    key={i}
                    onChange={handleForm}
                    name={e}
                    type='time'
                    id='outlined-required'
                    label={i === 0 ? 'Opening Time' : 'Closing Time'}
                    value={val}
                    InputLabelProps={{
                      shrink: true,
                      style: { fontSize: 17 }
                    }}
                  />
                )
              }
              )}
            </Box>

            <Button sx={{ padding: '10px 30px' }} variant='outlined' id='select-location-btn' onClick={() => setMapView(!mapView)}>
              <span className='material-symbols-outlined'> pin_drop </span>
              Select location on map
            </Button>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '49% 49%',
                gap: '1em',
                '& > :not(style)': { mb: 1, mt: 1 }
              }}
            >
              {['Longitude', 'Latitude'].map((e, i) =>
                <TextField
                  key={i}
                  sx={{ margin: '10px 0' }}
                  onChange={handleCoordinates}
                  required
                  name={e}
                  type='number'
                  id='outlined-number'
                  label={e}
                  value={center.location?.coordinates[i] || ''}
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: 20 }
                  }}
                />
              )}
            </Box>

            {formStatus === false
              ? <Stack> <Alert sx={{ fontSize: '18px' }} severity={formStatus ? 'success' : 'error'}>{!formStatus ? <FormErrors formResponse={formResponse} /> : 'Center details updated'}</Alert> </Stack>
              : null}

            <span style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Link to={'/center/' + id}>
                <Button sx={{ padding: '10px 30px' }} variant='outlined'>Cancel</Button>
              </Link>
              <Button sx={{ padding: '10px 30px' }} variant='contained' color='success' onClick={handleSubmit}>Submit</Button>
            </span>

          </form>
          : <Box sx={{ display: 'flex' }}> <CircularProgress sx={{ margin: '20vh auto ' }} /> </Box>}
        {mapView &&
          <Popover
            open={mapView}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'center'
            }}
            sx={{
              display: 'flex',
              padding: '5px',
              zIndex: 104
            }}
          >
            <SelectOnMap props={{ currentLocation, handleFormMap, handleLocation, location: center.location?.coordinates }} />
          </Popover>}
      </CardContent>
    </Card>
  )
}

const FormErrors = ({ formResponse }) => {
  return (
    <ul>
      Error updating center details :
      {formResponse.map((response, i) =>
        <li key={i}>{response}</li>
      )}
    </ul>
  )
}
